import { render } from "./VehicleMaster.vue?vue&type=template&id=6aaebedb&scoped=true"
import script from "./VehicleMaster.vue?vue&type=script&lang=js"
export * from "./VehicleMaster.vue?vue&type=script&lang=js"

import "./VehicleMaster.vue?vue&type=style&index=0&id=6aaebedb&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aaebedb"]])

export default __exports__